<!--答案解析-->
<template>
  <div class="uni-question-analysis">
    <div class="answer-box active">
      <!-- <div class="scorePoints" v-if="analysisDatas.question_style === 5">
        <div class="score">此题得分：{{ analysisDatas.answer_score }}分</div>
        <div class="scorePointsList" v-if="analysisDatas.score_points">
          <h3>得分点详情</h3>
          <ul>
            <li
              v-for="(item, index) in JSON.parse(analysisDatas.score_points)"
              :key="index"
            >
              <el-row :gutter="20">
                <el-col :span="22">
                  <div class="scoreCenter">
                    <p><em></em></p>
                    &nbsp;
                    {{ item.text === "null" ? "暂无内容" : item.text }} ({{
                      item.fraction === "null" ? 0 : item.fraction
                    }}分)
                  </div>
                </el-col>
                <el-col :span="2">
                  <p class="scoreDf">
                    得{{ item.hasScored ? item.hasScored : 0 }}分
                  </p>
                </el-col>
              </el-row>
            </li>
          </ul>
        </div>
      </div> -->

      <div class="p1">
        <div style="flex: 1">
          <p>
            您的答案：
            <span
              class="oringe mar40"
              v-if="(analysisDatas.choice_correct_item || analysisDatas.choice_correct_thumb) ? true : false"
              >{{ analysisDatas | getAnswer }}</span
            >
            <span class="oringe mar40" v-else>未作答</span>
          </p>
          <!-- 答案图片 -->
          <div v-if="Array.isArray(analysisDatas.choice_correct_thumb)">
            <div
              v-for="(item, index) in analysisDatas.choice_correct_thumb"
              :key="index"
            >
              <el-image
                class="mat20 mar10"
                style="width: 100px; color: #fff"
                fit="contain"
                :src="item"
                :preview-src-list="[item]"
              />
            </div>
          </div>
          <div v-else-if="analysisDatas.choice_correct_thumb ? true : false">
            <div
              v-for="(item, index) in analysisDatas.choice_correct_thumb.split(',')"
              :key="index"
            >
              <el-image
                class="mat20 mar10"
                style="width: 100px; color: #fff"
                fit="contain"
                :src="item"
                :preview-src-list="[item]"
              />
            </div>
          </div>

          <p
            class="mat30"
            style="display: flex"
            v-show="analysisDatas.question_style !== 5"
          >
            参考答案：
            <span style="line-height: 24px" class="yes">{{
              analysisDatas | getCorrect
            }}</span>
          </p>
        </div>
        <p v-if="makeType !== 7">
          <span
            class="opera"
            :class="isCollect ? 'oringe' : ''"
            @click="changeCollect"
          >
            <i class="iconfont iconshoucang1 mar5"></i>收藏
          </span>

          <span class="opera" @click="correctVisible = !correctVisible">
            <i class="iconfont iconcuotiku mar5"></i>纠错
          </span>
        </p>
      </div>

      <div class="p2">
        参考解析：
        <div class="resolve">
          <p
            style="line-height: 24px; white-space: pre-line"
            v-html="analysisDatas.analysis"
          ></p>
          <!-- 答案解析图片 -->
          <el-image
            v-if="analysisDatas.analyze_thumb"
            class="mat20"
            style="width: 100px; color: #fff"
            fit="contain"
            :src="analysisDatas.analyze_thumb"
            :preview-src-list="[analysisDatas.analyze_thumb]"
          />
        </div>
      </div>

      <div class="mat30" v-if="analysisDatas.source">
        知识点来源：{{ analysisDatas.source }}
      </div>

      <div class="note-box" v-if="makeType !== 7">
        <div class="my-note mat10">
          我的笔记：
          <div>
            <p>
              <el-button
                @click="isShowTextArea = !isShowTextArea"
                class="note-btn"
                type="warning"
              >
                <i class="iconfont iconbi"></i>
                记笔记
              </el-button>
            </p>

            <p class="textarea-box" :class="isShowTextArea ? 'active' : ''">
              <el-input
                v-model="noteContent"
                class="input mar10"
                type="textarea"
                rows="4"
              ></el-input>
              <el-button @click="saveNotes">提交</el-button>
            </p>
          </div>
        </div>

        <div class="note-list" v-if="noteList && noteList.length > 0">
          <el-timeline :reverse="true">
            <el-timeline-item
              v-for="(activity, index) in noteList"
              :key="index"
              type="primary"
              icon="el-icon-time"
              size="large"
              placement="top"
              :timestamp="activity.created_at"
              >{{ activity.content }}</el-timeline-item
            >
          </el-timeline>
        </div>
      </div>
    </div>

    <!-- 纠错弹框 -->
    <ComponentCorrect
      :topicId="analysisDatas.question_id"
      :visible.sync="correctVisible"
    />
  </div>
</template>

<script>
import ComponentCorrect from "@/components/componentCorrect.vue";
import { saveCollect, delCollect, addTopicNote } from "@/api/basic";
export default {
  name: "QuestionAnalysis",
  components: {
    ComponentCorrect,
  },
  props: {
    analysisDatas: {
      type: Object,
      default: () => {
        return {};
      },
    },
    makeType: {
      type: [String, Number],
      default: "",
    },
    course_id: {
      type: [String, Number],
      default: "",
    },
  },
  watch: {
    "analysisDatas.note": function (val) {
      this.noteList = val;
    },
  },
  mounted() {

  },
  data() {
    return {
      // course_id: this.$route.query.course_id,
      noteContent: "",
      noteList: this.analysisDatas.note,
      isShowTextArea: false,
      isCollect: this.analysisDatas.is_collect,
      correctVisible: false,
    };
  },
  filters: {
    getAnswer(item) {
      if (item.choice_correct_item) {
        let choice_correct_item = "";
        if (item.question_style !== 5) {
          choice_correct_item = JSON.parse(item.choice_correct_item);
        }

        switch (item.question_style) {
          case 4: //填空题
            return choice_correct_item.map((item) => item.value);
          case 2: //判断题
            // let mapInfo = ["A", "B", "c"];
            // let inx = choice_correct_item.key - 1;
            // return mapInfo[inx];
            let answerItem = item.judgment.find(v => v.key == choice_correct_item.key);
            let answer2 = answerItem.text;
            return answer2;
          case 5: //简答题
            return item.choice_correct_item;
          default:
            //单选题、多选题
            let answer = choice_correct_item.map((item) => item.option);
            return answer.join(",");
        }
      } else {
        return "";
      }
    },
    getCorrect(item) {
      if (item.correct_item) {
        let correct_item = JSON.parse(item.correct_item);
        switch (item.question_style) {
          case 4: //填空题
            return correct_item.map((item) => item.value);
          case 2: //判断题
            // let mapInfo = ["A", "B", "c"];
            // let inx = correct_item.key - 1;
            // return mapInfo[inx];
            let answerItem = item.judgment.find(v => v.key == correct_item.key);
            let answer2 = answerItem.text;
            return answer2;
          case 5: //简答题
            return item.correct_item;
          default:
            //单选题、多选题
            let answer = correct_item.map((item) => item.option);
            return answer.join(",");
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    /**
     * 记笔记
     */
    async saveNotes() {
      if (this.noteContent == "") {
        return;
      }
      const params = {
        course_id: this.course_id,
        content: this.noteContent,
        question_id: this.analysisDatas.question_id,
      };
      const res = await addTopicNote(params);
      if (res) {
        this.noteContent = "";
        this.$emit("noteChange");
      }
    },
    /**
     * 收藏
     */
    changeCollect() {
      if (this.isCollect) {
        this.cancelCollect();
      } else {
        this.putCollect();
      }
    },
    async putCollect() {
      const params = {
        course_id: this.course_id,
        question_id: this.analysisDatas.question_id,
      };
      const { result } = await saveCollect(params);
      if (result) {
        this.isCollect = true;
      }
    },
    /**
     * 取消收藏
     */
    async cancelCollect() {
      const params = {
        question_id: this.analysisDatas.question_id,
      };
      const res = await delCollect(params);
      if (res.code == 200) {
        this.isCollect = false;
      }
    },
  },
};
</script>
<style lang="scss">
.uni-question-analysis {
  .el-timeline,
  .el-timeline-item__timestamp {
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
.uni-question-analysis {
  .answer-box {
    width: 100%;
    padding-left: 20px;
    margin-top: 20px;
    height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    border-top: 0 solid $grayBorder;
    .scorePoints {
      width: 100%;
      background-color: #f8f8f8;
      margin-bottom: 40px;
      border-radius: 6px;
      .score {
        width: 100%;
        height: 60px;
        display: flex;
        padding: 0 20px;
        @include fontColor("primary");
        border-bottom: 1px solid $grayBorder;
        font-size: 16px;
        align-items: center;
      }
      .scorePointsList {
        width: 100%;
        padding: 20px;
        h3 {
          color: #333;
          font-size: 16px;
        }
        ul li {
          .scoreCenter {
            margin-top: 10px;
            display: flex;
            p {
              height: 100%;
              em {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #333;
                display: inline-block;
              }
            }
          }
          .scoreDf {
            @include fontColor("primary");
            margin-top: 10px;
          }
        }
      }
    }
    &.active {
      height: fit-content;
      padding-top: 26px;
      padding-bottom: 26px;
      border-top-width: 1px;
    }

    .yes {
      color: $green;
      padding-left: 5px;
      width: 90%;
    }

    .p1 {
      display: flex;
      justify-content: space-between;
      margin-right: 20px;
      .opera {
        cursor: pointer;
        margin-left: 10px;
      }
    }

    .p2 {
      display: flex;
      color: $grayLight;
      margin-top: 25px;

      .resolve {
        flex: 1;
        padding-left: 5px;
      }
    }

    .note-box {
      margin-top: 25px;

      .my-note {
        display: flex;

        .textarea-box {
          height: 0;
          overflow: hidden;
          display: flex;
          align-items: flex-end;
          transition: all 0.3s ease-in-out;

          &.active {
            height: fit-content;
            margin-top: 20px;
          }

          .input {
            width: 650px;
          }
        }
      }

      .note-list {
        margin-top: 20px;
        flex: 1;
        padding: 20px 70px;
        background: $grayBgLight;
      }
    }
    .note-btn {
      width: 90px;
      height: 32px;
      padding: 0 3px;
    }
  }
}
</style>
